import { MatDialogRef } from '@angular/material/dialog';
import { CompartmentOverview } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class CompartmentItemSetId {
  public static readonly type = '[CompartmentItem] Set Id';

  constructor(public payload: number) {}
}

export class CompartmentItemCreate {
  public static readonly type = '[CompartmentItem] Create Compartment';

  constructor(public payload: { hubId: number; compartmentOverview: CompartmentOverview }) {}
}

export class CompartmentItemNewSsccId {
  public static readonly type = '[CompartmentItem] Get new ssccId';

  constructor(public payload: { hubId: number }) {}
}

export class CompartmentItemDelete {
  public static readonly type = '[CompartmentItem] Delete Compartment';

  constructor(
    public payload: {
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      hubId: number;
      compartmentId: number;
    },
  ) {}
}

export class CompartmentItemNewCreate {
  public static readonly type = '[CompartmentItem] Create New Compartment';

  constructor(public payload: { hubId: number; compartmentOverview: CompartmentOverview }) {}
}

export class CompartmentItemInitialState {
  public static readonly type = '[CompartmentItem] Set initial state';
}
